module.exports = __webpack_public_path__ + "static/media/hearts-queen.78f8feef.png";